import { render } from "./AttachmentRadarChart.vue?vue&type=template&id=44a32c0e&scoped=true"
import script from "./AttachmentRadarChart.vue?vue&type=script&lang=js"
export * from "./AttachmentRadarChart.vue?vue&type=script&lang=js"

import "./AttachmentRadarChart.vue?vue&type=style&index=0&id=44a32c0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a32c0e"]])

export default __exports__